import React, { Component } from "react";
import * as moment from 'moment';
import { withRouter } from "react-router-dom";
import Countdown from 'react-countdown';

import { withStyles } from '@material-ui/core/styles';

import {
  Typography,
  Button,
  TextField,
  InputAdornment,
  Card,
  CardCountdown,
  CardContent,
  CardActions,
  CardHeader,
  Fab,
  Grid,
  List,
  ListItem,
  ListItemText,
  Tooltip,

} from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";

import Loader from '../loader'

import SearchIcon from '@material-ui/icons/Search';

import Store from "../../stores";
import { colors } from '../../theme'

import {
  ERROR,
  START_LOADING,
  STOP_LOADING,
  CONNECTION_CONNECTED,
  ACCOUNT_CHANGED,
  GET_CURRENT_BLOCK,
  CURRENT_BLOCK_RETURNED,
  GET_LOCKER,
  LOCKER_RETURNED,
  GET_JOBS,
  JOBS_RETURNED,
  GET_LOCKERS,
  LOCKERS_RETURNED,
  ADD_BOND,
  ADD_BOND_RETURNED,
  REMOVE_BOND,
  REMOVE_BOND_RETURNED,
  ACTIVATE_BOND,
  ACTIVATE_BOND_RETURNED,
  WITHDRAW_BOND,
  WITHDRAW_BOND_RETURNED,
  SWAP_APPROVE,
  SWAP_APPROVED,
  SWAP_EXECUTE,
  SWAP_APPROVE_RETURNED,
  SWAP_EXECUTE_RETURNED, TRANSFER_RIGHTS, TRANSFER_RIGHTS_RETURNED
} from '../../constants'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Web3 from "web3";
import Box from "@material-ui/core/Box";

const styles = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '900px',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // paddingBottom: '60px',
    // background: colors.white,
  },
  grid: {
    flexGrow: 1,
  },
  between: {
    width: '40px'
  },
  intro: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '900px',
    marginBottom: '20px',
    // background: colors.white,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginBottom: '10px',
    }
  },
  topButton: {
    width: '160px',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '90vw',
    }
  },
  disclaimer: {
    padding: '12px',
    border: '1px solid rgb(174, 174, 174)',
    borderRadius: '10px',
    marginBottom: '24px',
    background: colors.white,
    [theme.breakpoints.down('sm')]: {
      minWidth: '90vw',
    }
  },
  lockerLayout: {
    display: 'flex',
    maxWidth: '1200px',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  profileContainer: {
    display: 'flex',
    width: '300px',
    border: '1px solid '+colors.borderBlue,
    borderRadius: '10px',
    padding: '24px',
    marginRight: '20px',
    flexDirection: 'column',
    background: colors.white,
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      minWidth: '90vw',
      marginRight: '0px',
      marginBottom: '25px'
    }
  },
  valueContainer: {
    width: '100%',
    margin: '12px 0px',
    position: 'relative'
  },
  valueTitle: {
    color: colors.darkGray,
    marginBottom: '6px'
  },
  valueValue: {

  },
  valueAction: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  valueActionBonds: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  valueActionBondsAction: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '100%'
  },
  jobsContainer: {
    display: 'flex',
    flex: 1,
    border: '1px solid '+colors.borderBlue,
    borderRadius: '10px',
    padding: '24px',
    marginLeft: '20px',
    flexDirection: 'column',
    background: colors.white,
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      maxWidth: '90vw',
      marginBottom: '20px'

    },
      },
      cardActions: {
        // zIndex: 2,
        // display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        // flexWrap: 'wrap',
        // padding: 0,
  },
  title: {
    width: '100%',
    borderBottom: '1px solid '+colors.borderBlue,
    paddingBottom: '12px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: '40px'
  },
  inputContainer: {
    flex: 1,
    display: 'flex',
    position: 'relative',
  },
  balance: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    position: 'absolute',
    zIndex: 1,
    right: '8px',
    top: '2px',
    letterSpacing: '0.1rem',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  textField: {
    flex: 1,
    width: '100%',
  },
  valueActionButtons: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '12px'
  },
  searchInputAdornment: {
    cursor: 'pointer'
  },
  actionInput: {
    // background: colors.white
  },
  jobContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '12px 0px',
    '&:hover': {
      background: "rgba(0,0,0,0.1)",
    },
  },
  gray: {
    color: colors.darkGray,
  },
  totalCredits: {
    textAlign: 'right'
  }
})

const emitter = Store.emitter
const dispatcher = Store.dispatcher
const store = Store.store

class Locker extends Component {

  constructor(props) {
    super()

    const account = store.getStore('account')
    const lockerAsset = store.getStore('lockerAsset')
    const jobs = store.getStore('jobs').filter((job) => { return job.credits > 0 });
    const now = store.getStore('currentBlock')

    this.state = {
      loading: true,
      account: account,
      lockerAsset: lockerAsset,
      jobs: jobs,
      bondAmount: '',
      bondAmountError: false,
      removeBondAmount: '',
      removeBondAmountError: false,
      currentBlock: now,
      approved:false,
      swapped:false,
      transferTo: '',
    };

    emitter.emit(START_LOADING, GET_LOCKER)
    emitter.emit(START_LOADING, GET_JOBS)
    emitter.emit(START_LOADING, GET_LOCKERS)
    emitter.emit(START_LOADING, GET_CURRENT_BLOCK)
    dispatcher.dispatch({ type: GET_LOCKER, content: {} })
    dispatcher.dispatch({ type: GET_JOBS, content: {} })
    dispatcher.dispatch({ type: GET_LOCKERS, content: {} })
    dispatcher.dispatch({ type: GET_CURRENT_BLOCK, content: { } })
  };

  componentWillMount() {
    emitter.on(ERROR, this.errorReturned);
    emitter.on(LOCKER_RETURNED, this.lockerProfileReturned)
    emitter.on(JOBS_RETURNED, this.jobsReturned);
    emitter.on(LOCKERS_RETURNED, this.lockersReturned);
    emitter.on(CONNECTION_CONNECTED, this.connectionConnected);
    emitter.on(ACCOUNT_CHANGED, this.connectionConnected);
    emitter.on(ADD_BOND_RETURNED, this.addBondReturned);
    emitter.on(REMOVE_BOND_RETURNED, this.removeBondReturned);
    emitter.on(ACTIVATE_BOND_RETURNED, this.activateBondReturned);
    emitter.on(WITHDRAW_BOND_RETURNED, this.withdrawBondReturned);
    emitter.on(SWAP_APPROVE_RETURNED, this.swapApproveReturned);
    emitter.on(SWAP_EXECUTE_RETURNED, this.swapExecuteReturned);
    emitter.on(CURRENT_BLOCK_RETURNED, this.currentBlockReturned);
    emitter.on(TRANSFER_RIGHTS_RETURNED, this.transferRightsReturned)
  };

  componentWillUnmount() {
    emitter.removeListener(ERROR, this.errorReturned);
    emitter.removeListener(LOCKER_RETURNED, this.lockerProfileReturned)
    emitter.removeListener(JOBS_RETURNED, this.jobsReturned);
    emitter.removeListener(LOCKERS_RETURNED, this.lockersReturned);
    emitter.removeListener(CONNECTION_CONNECTED, this.connectionConnected);
    emitter.removeListener(ACCOUNT_CHANGED, this.connectionConnected);
    emitter.removeListener(ADD_BOND_RETURNED, this.addBondReturned);
    emitter.removeListener(REMOVE_BOND_RETURNED, this.removeBondReturned);
    emitter.removeListener(ACTIVATE_BOND_RETURNED, this.activateBondReturned);
    emitter.removeListener(WITHDRAW_BOND_RETURNED, this.withdrawBondReturned);
    emitter.removeListener(CURRENT_BLOCK_RETURNED, this.currentBlockReturned);
    emitter.removeListener(TRANSFER_RIGHTS_RETURNED, this.transferRightsReturned)
  };

  connectionConnected = () => {
    emitter.emit(START_LOADING, GET_LOCKER)
    emitter.emit(START_LOADING, GET_JOBS)
    emitter.emit(START_LOADING, GET_LOCKERS)
    emitter.emit(START_LOADING, GET_CURRENT_BLOCK)
    emitter.emit(START_LOADING, SWAP_APPROVED);
    dispatcher.dispatch({ type: SWAP_APPROVED, content: {} });
    dispatcher.dispatch({ type: GET_LOCKER, content: {} })
    dispatcher.dispatch({ type: GET_JOBS, content: {} })
    dispatcher.dispatch({ type: GET_LOCKERS, content: {} })
    dispatcher.dispatch({ type: GET_CURRENT_BLOCK, content: { } })
  };

  errorReturned = (source) => {
    emitter.emit(STOP_LOADING, source)
    this.setState({ loading: false })
  };

  lockerProfileReturned = () => {
    emitter.emit(STOP_LOADING, GET_LOCKERS)

    console.log(store.getStore('lockerAsset'))

    this.setState({
      lockerAsset: store.getStore('lockerAsset'),
      loading: false
    })
  }

  jobsReturned = () => {
    emitter.emit(STOP_LOADING, GET_JOBS)
    this.setState({ jobs: store.getStore('jobs').filter((job) => { return job.credits > 0 }) })
  }

  lockersReturned = () => {
    emitter.emit(STOP_LOADING, GET_LOCKERS)
    this.setState({ lockers: store.getStore('lockers') })
  }

  addBondReturned = () => {
    this.setState({
      loading: false,
      onBond: false,
    })
    emitter.emit(STOP_LOADING, ADD_BOND)
  }

  removeBondReturned = () => {
    this.setState({
      loading: false,
      onBondRemove: false,
    })
    emitter.emit(STOP_LOADING, REMOVE_BOND)
  }

  activateBondReturned = () => {
    this.setState({
      loading: false,
    })
    emitter.emit(STOP_LOADING, ACTIVATE_BOND_RETURNED)
  }


  withdrawBondReturned = () => {
    this.setState({
      loading: false,
    })
    emitter.emit(STOP_LOADING, WITHDRAW_BOND)
  }
  swapApproveReturned = () => {
    this.setState({
      loading: false,
      approved:true
    })
    emitter.emit(STOP_LOADING, SWAP_APPROVE)
  }
  swapExecuteReturned = () => {
    this.setState({
      loading: false,
      swapped:true
    })
    emitter.emit(STOP_LOADING, SWAP_EXECUTE)
  }
  currentBlockReturned = () => {
    emitter.emit(STOP_LOADING, GET_CURRENT_BLOCK)
    this.setState({ currentBlock: store.getStore('currentBlock') });
  };

  transferRightsReturned = () => {
        emitter.emit(STOP_LOADING, TRANSFER_RIGHTS);
  }
  render() {
    const { classes } = this.props;
    const {
      loading,
      lockerAsset,
      lockers,
      onBond,
      onBondRemove,
      currentBlock,
      searchLocker,
      searchLockerError,
    } = this.state;

    // var delegates = 'Self';
    // if (lockerAsset.delegates && lockerAsset.delegates !== '0x0000000000000000000000000000000000000000') {
    //   delegates = lockerAsset.delegates.substring(0,6)+'...'+lockerAsset.delegates.substring(lockerAsset.delegates.length-4,lockerAsset.delegates.length)
    // }

    return (
      <div className={ classes.root }>
        <div className={ classes.lockerLayout }>
          <Card className={ classes.profileContainer }>
            <Typography variant='h3' className={ classes.title }>Profile</Typography>
            <div className={ classes.valueContainer }>
              <Typography variant='h4' className={ classes.valueTitle }>Balance</Typography>
              <Typography variant='h3' className={ classes.valueValue }> { lockerAsset.balance ? lockerAsset.balance.toFixed(2) : '0.00' } { lockerAsset.symbol } </Typography>
            </div>
            <div className={ classes.valueContainer }>
              <Typography variant='h4' className={ classes.valueTitle }>Bonds</Typography>
              { (!onBond && !onBondRemove) && this.renderBond() }
              { onBond && this.renderBondAdd() }
              { onBondRemove && this.renderBondRemove() }
            </div>
            { this.renderPendingBonds() }
            { this.renderActivateBonds(loading) }
            { this.renderPendingUnbonds() }
            { this.renderWithdrawBonds() }
            { this.renderWorkCompleted() }
            { this.renderFirstSeen() }
            { this.renderTransferButton() }
            { this.renderSearch() }
            
          </Card>
          <Card className={classes.jobsContainer}>
            <CardHeader
              title={
                // <div className={classes.title}>
                <Typography variant="h3">Jobs</Typography>
              }
              action={
                <Tooltip title="Add Job" aria-label="add">
                  <Fab
                    color="primary"
                    size="medium"
                    // variant="extended"
                    color="primary"
                    onClick={this.onAddJob}
                    aria-label="add"
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
              }
            ></CardHeader>
            <CardContent>
              <List component="nav" aria-label="main mailbox folders">
                {this.renderJobs()}
              </List>
            </CardContent>
            <CardActions className={classes.cardActions}>
              {/* <Button
                variant="contained"
                size="medium"
                color="primary"
                onClick={this.onAddJob}
              >
                Add
              </Button> */}
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }

       

  renderSearch = () => {
    const { classes } = this.props
    const { loading, searchLocker, searchLockerError } = this.state

    return (
      <div className={ classes.valueContainer }>
        <TextField
          fullWidth
          disabled={ loading }
          className={ classes.actionInput }
          id={ 'searchLocker' }
          value={ searchLocker }
          error={ searchLockerError }
          onChange={ this.onSearchChange }
          label="Find Lock3r"
          onKeyDown= { this.onSearchKeyDown }
          InputProps={{
            endAdornment: <InputAdornment position="end" className={ classes.searchInputAdornment } onClick={ this.onSearch }><SearchIcon /></InputAdornment>,
          }}
        />
      </div>
    )
  }
  

   removeDuplicates = (originalArray, prop) =>{
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
  }

  renderJobs = () => {
    const { classes } = this.props
    var { jobs, lockerAsset } = this.state
    jobs = this.removeDuplicates(jobs,"address");
    if(jobs.length === 0) {
      return (<div>
        <Typography variant='h4'>There are no jobs</Typography>
      </div>);
    }

    return jobs.map((job) => {

      var address = null;
      if (job.address) {
        address = job.address.substring(0,6)+'...'+job.address.substring(job.address.length-4,job.address.length)
      }

      return (
        <ListItem
          alignItems="flex-start"
          button
          onClick={() => {
            this.navJob(job.address);
          }}
        >
          <ListItemText
            className={classes.jobContainer}
            key={job.address}
            primary={
              <React.Fragment>
                <div>
                  <Typography variant="h4">{job._name}</Typography>
                  <Typography
                    variant="h4"
                    className={classes.textColorSecondary}
                  >
                    {address}
                  </Typography>
                </div>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <div className={classes.totalCredits}>
                  <Typography
                    variant="h4"
                    className={classes.textColorSecondary}
                  >
                    Total Credits
                  </Typography>
                  <Typography variant="h4">
                    {job.credits ? job.credits.toFixed(2) : "0.00"}{" "}
                    {lockerAsset ? lockerAsset.symbol : ""}
                  </Typography>
                </div>
              </React.Fragment>
            }
          />
        </ListItem>
      );
    });
  };
  

  renderFirstSeen = () => {
    const { classes } = this.props
    const { lockerAsset } = this.state

    if(lockerAsset.isActive) {
      return (
        <React.Fragment>
          <div className={ classes.valueContainer }>
            <Typography variant='h4' className={ classes.valueTitle }>First Seen</Typography>
            <Typography variant='h3' className={ classes.valueValue }> { moment(lockerAsset.firstSeen*1000).format("YYYY/MM/DD kk:mm") }</Typography>
          </div>
          <div className={ classes.valueContainer }>
            <Typography variant='h4' className={ classes.valueTitle }>Last Job</Typography>
            <Typography variant='h3' className={ classes.valueValue }> { moment(lockerAsset.lastJob*1000).format("YYYY/MM/DD kk:mm") }</Typography>
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }
  renderTransferButton = () => {
        const { classes } = this.props
        const { lockerAsset,loading } = this.state
        const {transfertDialogOpen } = this.state
        const { transferTo } = this.state
        const openTransferDialog = () => {
          this.setState({
            transfertDialogOpen: true,
          });
        }
        const closeDialog = () => {
          this.setState({
            transfertDialogOpen: false,
            transferTo: "",
          });
        }
        const setTransferTo = (value) => {
          this.setState({
            transferTo: value,
          });	
        }
        if(lockerAsset.isActive) {	
          return (
              <React.Fragment>
                <div className={ classes.valueContainer }>
                  <Typography variant='h4' className={ classes.valueTitle }>Transfer locker rights</Typography>
                  <Button color={"primary"} variant={"contained"} onClick={openTransferDialog}>Transfer</Button>
                </div>
                <Dialog onClose={closeDialog} aria-labelledby="transfer-locker-rights-dialog-title" open={!!transfertDialogOpen}>
                  <DialogTitle id="transfer-locker-rights-dialog-title">Transfer your locker rights</DialogTitle>
                  <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="to"
                        label="To address"
                        disabled={loading}
                        fullWidth
                        value={transferTo}
                        onChange={e => setTransferTo(e.target.value)}
                        error={this.state.transferToError}
                        helperText={this.state.transferToError}
                        style={{width:500}}
                    />
                    <Box textAlign={"center"} my={2}>
                      <Button color="primary" variant="contained" size="small" disabled={loading} onClick={this.onTransfer}>
                        Transfer
                      </Button>
                    </Box>
                  </DialogContent>
                </Dialog>
              </React.Fragment>
          )
        } else {
          return null
        }
  }

  renderWorkCompleted = () => {
    const { classes } = this.props
    const { lockerAsset } = this.state

    return (
      <div className={ classes.valueContainer }>
        <Typography variant='h4' className={ classes.valueTitle }>Work Completed</Typography>
        <Typography variant='h3' className={ classes.valueValue }>{ (lockerAsset.workCompleted ? lockerAsset.workCompleted.toFixed(4) : '0' )+ ` ${lockerAsset.symbol}`}</Typography>
      </div>
    )

  }

  renderBond = () => {
    const { classes } = this.props
    const {
      lockerAsset,
    } = this.state

    return (
      <div className={ classes.valueActionBonds }>
        <Typography variant='h3' className={ classes.valueValue }>
        {" "}
          {lockerAsset.bonds ? (lockerAsset.bonds - lockerAsset.workCompleted).toFixed(2) : "0.00"}{" "}
          {lockerAsset.symbol}{" "}
        </Typography>
        <Grid container className={classes.grid} spacing={4}>
          <Grid item xs={12}>
            <Grid container justify="center" spacing={2}>
              <Grid key={"bond"} item>
                <Button size="small" color="primary" onClick={this.onBondAdd}>
                 Bond
                </Button>
              </Grid>
              <Grid key={"unbond"} item>
                <Button size="small" color="primary" onClick={this.onBondRemove}>
                  Unbond
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };


  renderPendingBonds = () => {
    const { classes } = this.props
    const {
      lockerAsset,
    } = this.state

    if(lockerAsset.isActive && lockerAsset.pendingBonds === 0) {
      return null
    } else if(parseInt(lockerAsset.bondings) - parseInt(lockerAsset.bondingDelay)  > 0) {
      return (
        <div className={ classes.valueContainer }>
          <Typography variant='h4' className={ classes.valueTitle }>Bonds pending activation</Typography>
          <div className={ classes.valueAction }>
            <Typography variant='h3' className={ classes.valueValue }> { lockerAsset.pendingBonds ? lockerAsset.pendingBonds.toFixed(2) : '0.00' } { lockerAsset.symbol } </Typography>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderActivateBonds = (loading) => {
    const { classes } = this.props
    const {
      lockerAsset,
    } = this.state

    if(lockerAsset.isActive && lockerAsset.pendingBonds === 0) {
      return null
    } else if(parseInt(lockerAsset.bondings) - parseInt(lockerAsset.bondingDelay) > 0 && moment(lockerAsset.bondings*1000).valueOf() < moment().valueOf() && lockerAsset.pendingBonds) {
      return (
        <div className={ classes.valueContainer }>
          <Typography variant='h4' className={ classes.valueTitle }>Activate</Typography>
          <Button
            variant='contained'
            size='small'
            color='primary'
            onClick={ this.onActivate }
            disabled={loading}
          >
            Activate Bonds
          </Button>
        </div>
      )
    } else if (parseInt(lockerAsset.bondings) - parseInt(lockerAsset.bondingDelay) > 0 && lockerAsset.pendingBonds) {
      return (
        <div className={ classes.valueContainer }>
          <Typography variant='h4' className={ classes.valueTitle }>Bonds are activatable on:</Typography>
          <div className={ classes.valueAction }>
            <Typography variant='h3' className={ classes.valueValue }> { moment(lockerAsset.bondings*1000).format("YYYY/MM/DD kk:mm") } </Typography>
          </div>
        </div>
      )
    }
  }

  renderPendingUnbonds = () => {
    const { classes } = this.props
    const {
      lockerAsset,
    } = this.state

    if(parseInt(lockerAsset.unbondings) - parseInt(lockerAsset.unbondingDelay) > 0 && lockerAsset.partialUnbonding) {
      return (
        <div className={ classes.valueContainer }>
          <Typography variant='h4' className={ classes.valueTitle }>Unbonds pending</Typography>
          <div className={ classes.valueAction }>
            <Typography variant='h3' className={ classes.valueValue }> { lockerAsset.partialUnbonding ? lockerAsset.partialUnbonding.toFixed(2) : '0.00' } { lockerAsset.symbol } </Typography>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderWithdrawBonds = () => {
    const { classes } = this.props
    const {
      lockerAsset,
      withdrawBondAmount,
      withdrawBondAmountError,
      loading
    } = this.state

    if((parseInt(lockerAsset.unbondings)- parseInt(lockerAsset.unbondingDelay))  > 0 && moment(lockerAsset.unbondings*1000).valueOf() < moment().valueOf() && lockerAsset.partialUnbonding) {
      return (
        <div>
          <div className={ classes.valueActionButtons }>
            <Button
              variant='text'
              size='small'
              color='primary'
              onClick={ this.onBondAddClose }
            >
              cancel
            </Button>
          </div>
        </div>
      )
    } else if ((parseInt(lockerAsset.unbondings) - parseInt(lockerAsset.unbondingDelay) ) >0 && lockerAsset.partialUnbonding) {
      return (
        <div className={ classes.valueContainer }>
          <Typography variant='h4' className={ classes.valueTitle }>Withdrawable at</Typography>
          <div className={ classes.valueAction }>
            <Typography variant='h3' className={ classes.valueValue }> { moment(lockerAsset.unbondings*1000).format("YYYY/MM/DD kk:mm") } </Typography>
          </div>
        </div>
      )
    }
  }

  renderBondAdd = () => {
    const { classes } = this.props
    const {
      lockerAsset,
      bondAmount,
      bondAmountError,
      loading
    } = this.state

    return (
      <div>
        <div className={ classes.inputContainer }>
          <Typography variant='h6' className={ classes.balance } onClick={ () => { this.maxClicked('bond') } }>{ lockerAsset.balance.toFixed(4) } { lockerAsset.symbol }</Typography>
          <TextField
            fullwidth
            disabled={ loading }
            id='bondAmount'
            variant='outlined'
            color='primary'
            className={ classes.textField }
            placeholder='Amount to bond'
            value={ bondAmount }
            error={ bondAmountError }
            onChange={ this.onChange }
            InputProps={{
              className: classes.inputField,
              startAdornment: (<InputAdornment position="start" className={ classes.inputAdornment }>
                <img src={ require('../../assets/tokens/'+lockerAsset.logo) } width="30px" alt="" />
              </InputAdornment>),
            }}
          />
        </div>
        <div className={ classes.valueActionButtons }>
          <Button
            variant='text'
            size='small'
            color='primary'
            onClick={ this.onBondAddClose }
          >
            cancel
          </Button>
          <Button
            variant='contained'
            size='small'
            color='primary'
            onClick={ this.onBond }
          >
            bond
          </Button>
        </div>
      </div>
    )
  }

  renderBondRemove = () => {
    const { classes } = this.props
    const {
      lockerAsset,
      removeBondAmount,
      removeBondAmountError,
      loading
    } = this.state

    return (
      <div>
        <div className={ classes.inputContainer }>
          <Typography variant='h6' className={ classes.balance } onClick={ () => { this.maxClicked('bondRemove') } }>{ lockerAsset.bonds.toFixed(4) } { lockerAsset.symbol }</Typography>
          <TextField
            fullwidth
            disabled={ loading }
            id='removeBondAmount'
            variant='outlined'
            color='primary'
            className={ classes.textField }
            placeholder='Amount to unbond'
            value={ removeBondAmount }
            error={ removeBondAmountError }
            onChange={ this.onChange }
            InputProps={{
              className: classes.inputField,
              startAdornment: <InputAdornment position="start" className={ classes.inputAdornment }>
                <img src={ require('../../assets/tokens/'+lockerAsset.logo) } width="30px" alt="" />
              </InputAdornment>
            }}
          />
        </div>
        <div className={ classes.valueActionButtons }>
          <Button
            variant='text'
            size='small'
            color='primary'
            onClick={ this.onBondRemoveClose }
          >
            cancel
          </Button>
          <Button
            variant='contained'
            size='small'
            color='primary'
            onClick={ this.onCallBondRemove }
          >
            unbond
          </Button>
        </div>
      </div>
    )
  }

  maxClicked = (type) => {
    const {
      lockerAsset
    } = this.state

    switch (type) {
      case 'bond':
        this.setState({ bondAmount: lockerAsset.balance })
        break;
      case 'bondRemove':
        this.setState({ removeBondAmount: (lockerAsset.bonds - lockerAsset.workCompleted) });
        break;
      case 'bondWithdraw':
        this.setState({ withdrawBondAmount: lockerAsset.bonds })
        break;
      case 'swapTokens':
        this.setState({swapAmount: lockerAsset.balance})
        break;
      default:
    }
  }

  onSearchChange = (event) => {
    let val = []
    val[event.target.id] = event.target.value
    this.setState(val)
  }

  onSearchKeyDown = (event) => {
    if (event.which === 13) {
      this.onSearch();
    }
  }

  onSearch = () => {
    this.setState({ searchLockerError: false })
    const {
      searchLocker
    } = this.state

    let error = false

    if(!searchLocker || searchLocker === "") {
      this.setState({ searchLockerError: 'Invalid' })
      error = true
    }

    if(!error) {
      this.props.history.push('/lock3r/'+searchLocker)
    }
  }

  onChange = (event) => {
    if(event.target.value !== '' && isNaN(event.target.value)) {
      return false
    }

    const { lockerAsset } = this.state;
    if(
    event.target.id === "bondAmount" &&
    event.target.value > lockerAsset.balance) {
      event.target.value = lockerAsset.balance
    }
    if(event.target.id === 'removeBondAmount' && 
      event.target.value > lockerAsset.bonds){
      event.target.value = lockerAsset.bonds
    }

    let val = []
    val[event.target.id] = event.target.value
    this.setState(val)
  }

  onBond = () => {
    this.setState({ bondAmountError: false })
    const { lockerAsset, bondAmount } = this.state

    let error = false

    if(bondAmount > lockerAsset.balance) {
      error = true
      this.setState({ bondAmountError: 'Amount > balance' })
    }

    if(!error) {
      emitter.emit(START_LOADING, ADD_BOND)
      this.setState({ loading: true })
      dispatcher.dispatch({ type: ADD_BOND, content: { amount: bondAmount } })
    }
  }
  onWithdraw = () => {
    emitter.emit(START_LOADING, WITHDRAW_BOND);
    this.setState({ loading: true });
    dispatcher.dispatch({ type: WITHDRAW_BOND});
};


  onCallBondRemove = () => {
    this.setState({ bondAmountError: false })
    const { lockerAsset, removeBondAmount } = this.state

    let error = false

    if(removeBondAmount > lockerAsset.bonds) {
      error = true
      this.setState({ removeBondAmountError: 'Amount > bonded balance' })
    }

    if(!error) {
      emitter.emit(START_LOADING, REMOVE_BOND)
      this.setState({ loading: true })
      dispatcher.dispatch({ type: REMOVE_BOND, content: { amount: removeBondAmount } })
    }
  };

onSwapApprove = () => {
  let error = false;

  if (!error) {
    emitter.emit(START_LOADING, SWAP_APPROVE);
    this.setState({ loading: true });
    dispatcher.dispatch({ type: SWAP_APPROVE});
  }
};

onSwapExecute = () => {
  let error = false;

  if (!error) {
    emitter.emit(START_LOADING, SWAP_EXECUTE);
    this.setState({ loading: true });
    dispatcher.dispatch({ type: SWAP_EXECUTE});
  }
};

onCallBondRemove = () => {
  this.setState({ bondAmountError: false });
  const { lockerAsset, removeBondAmount } = this.state;

  let error = false;

  if(removeBondAmount > lockerAsset.bonds) {
    error = true
    this.setState({ removeBondAmountError: 'Amount > bonded balance' })
  }

  if (!error) {
    emitter.emit(START_LOADING, REMOVE_BOND);
    this.setState({ loading: true });
    dispatcher.dispatch({
      type: REMOVE_BOND,
      content: { amount: removeBondAmount },
    });
  }
};

onBondAdd = () => {
  this.setState({ onBond: true });
};

onBondAddClose = () => {
  this.setState({ onBond: false });
};

onBondRemove = () => {
  this.setState({ onBondRemove: true });
};

onBondRemoveClose = () => {
  this.setState({ onBondRemove: false });
};

onActivate = () => {
  emitter.emit(START_LOADING, ACTIVATE_BOND);
  this.setState({ loading: true });
  dispatcher.dispatch({ type: ACTIVATE_BOND, content: {} });
};

onAddJob = () => {
  this.props.history.push("/lock3r/job");
};

onTransfer = () => {
  let error = false;
  if (!Web3.utils.isAddress(this.state.transferTo)){
    error = true;
    this.setState({transferToError: "This is not a valid address"});
  }
  if (!error) {
    emitter.emit(START_LOADING, TRANSFER_RIGHTS);
    this.setState({ loading: true, transferToError: null });
    dispatcher.dispatch({ type: TRANSFER_RIGHTS, content: { to: this.state.transferTo } });
  }
}

navJob = (address) => {
  this.props.history.push("/lock3r/job/" + address);
};
}

export default withRouter(withStyles(styles)(Locker));